import * as React from 'react'
import * as SwitchPrimitives from '@radix-ui/react-switch'

import { cn } from '@/helpers/utils'
import { Icon } from '@/components/common/icons/Icon'

export type SwitchProps = React.ComponentPropsWithoutRef<
  typeof SwitchPrimitives.Root
>

const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  SwitchProps
>(({ className, ...props }, ref) => (
  <SwitchPrimitives.Root
    className={cn(
      'peer inline-flex h-full w-[59px] shrink-0 cursor-pointer items-center rounded-full border border-border p-0.5 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-background data-[state=unchecked]:bg-neutral-light',
      className,
    )}
    {...props}
    ref={ref}
  >
    <SwitchPrimitives.Thumb
      className={cn(
        'group/thumb pointer-events-none flex h-6 w-6 items-center justify-center rounded-full shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-[30px] data-[state=unchecked]:translate-x-0 data-[state=checked]:bg-primary-light data-[state=unchecked]:bg-input',
      )}
    >
      <Icon
        className="hidden text-background group-data-[state=unchecked]/thumb:block"
        tag="remove"
        size="xl"
      />
      <Icon
        className="hidden text-background group-data-[state=checked]/thumb:block"
        tag="check"
        size="xl"
      />
    </SwitchPrimitives.Thumb>
  </SwitchPrimitives.Root>
))
Switch.displayName = SwitchPrimitives.Root.displayName

export { Switch }
